// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
 brandName: "Dharti Public School,Sigikeri",
     contact: "+91 9900294284,7204148768 | devibaiiti@gmail.com",
     socialLinks: {
       instagram: "https://www.instagram.com/dharti_public_school/?hl=en",
       whatsapp:   "https://wa.me/yourwhatsapplink",
       youtube:    "https://www.youtube.com/@dhartischool966",
       facebook:   "https://www.facebook.com/",
       twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
